import { useDispatch, useSelector } from "react-redux";
import { TextComponent } from "../../../../core/components/TextComponent";
import SettingComponent from "./SettingComponent";
import { AppDispatch, RootState } from "../../../../core/store/store";
import { Clock } from "../../../../core/icons/Clock";
import { Check } from "../../../../core/icons/Check";
import { Cancel } from "../../../../core/icons/Cancel";
import { useState } from "react";
import { OtpVerification } from "../pages/OtpVerification";
import { setEmails } from "../../../profile/presentation/store/OnboardingSlice";
import { ModalSimple } from "../../../../core/components/Modal";
import { CheckVerifyBG } from "../../../../core/icons/CheckVerifyBG";
import { VerificationModal } from "../pages/VerificationMode";
import { useNavigate } from "react-router-dom";
enum VerificationStatus {
  Rejected = "Rejected",
  Unverified = "Unverified",
  Pending = "Pending",
  Verified = "Verified",
  LiveFaceRequired = "Live face check required",
}

export const AccountSettings = () => {
  const dispatch: AppDispatch = useDispatch();
  const { user, getProfileConfig } = useSelector(
    (state: RootState) => state.onboarding,
  );
  const emailVerified = user?.email
    ? ("Verified" as "Verified")
    : ("Unverified" as "Unverified");
  const navigate = useNavigate();
  const status = getProfileConfig?.status_account;
  const [statusModalOpen, setStatusModalOpen] = useState<boolean>(false);
  const [infoModalOpen, setInfoModalOpen] = useState<boolean>(false);
  const [verificationType, setVerificationType] = useState<"0">("0");
  const [isEmailModalOpen, setIsEmailModalOpen] = useState<boolean>(false);
  const [email, setEmail] = useState<string>("");
  const [isOtpModalOpen, setIsOtpModalOpen] = useState<boolean>(false);
  const isLiveFaceRequired = status === "live_face_required";

  const handleContinueEmail = (email: string) => {
    setEmail(email);
    setVerificationType("0");
    setIsEmailModalOpen(false);
    setIsOtpModalOpen(true);
  };
  const menuItems = [
    {
      icon:
        status === "rejected" || status === null || isLiveFaceRequired ? (
          <Cancel />
        ) : status === "pending" ? (
          <Clock />
        ) : (
          <Check />
        ),
      title: "Verification Status",
      status: isLiveFaceRequired
        ? VerificationStatus.LiveFaceRequired
        : status === "rejected"
          ? VerificationStatus.Rejected
          : status === null
            ? VerificationStatus.Unverified
            : status === "pending"
              ? VerificationStatus.Pending
              : VerificationStatus.Verified,
      onClick: () => {
        if (status === "pending" || status === "verified") {
          setStatusModalOpen(true);
          return;
        }
        navigate("/settings/statusVerification");
      },
    },
    {
      icon:
        emailVerified === VerificationStatus.Verified ? <Check /> : <Cancel />,
      title: "Email Verification",
      status: emailVerified,
      path: "/email-verification",
      onClick: () => {
        if (emailVerified === VerificationStatus.Verified) {
          setInfoModalOpen(true);
          setVerificationType("0");
        } else {
          setVerificationType("0");
          setIsEmailModalOpen(true);
        }
      },
    },
    {
      title: "Change password",
      onClick: () => {
        navigate("/settings?section=change-password");
      },
    },
  ];

  const handleOtpSuccess = () => {
    dispatch(setEmails(email));
  };

  return (
    <>
      <TextComponent variant="h2" className="font-semibold mb-5">
        Account settings
      </TextComponent>
      {menuItems.map((item) => (
        <SettingComponent
          key={item.title}
          icon={item.icon}
          title={item.title}
          className="bg-gray-100 select-none hover:bg-gray-200 transition-colors duration-300 ease-in-out"
          status={item.status}
          onClick={item.onClick}
        />
      ))}
      <OtpVerification
        isOpen={isOtpModalOpen}
        onRequestClose={() => setIsOtpModalOpen(false)}
        email={email}
        type={verificationType}
        onVerificationSuccess={handleOtpSuccess}
      />
      <VerificationModal
        isOpen={isEmailModalOpen}
        onRequestClose={() => setIsEmailModalOpen(false)}
        onContinue={handleContinueEmail}
        type={verificationType}
      />
      <ModalSimple
        title="Information"
        variant="secondary"
        actionExecuted={statusModalOpen}
        onClose={() => {
          setStatusModalOpen(false);
        }}
        icon={<CheckVerifyBG />}
        next
      >
        {status === "pending" ? (
          <TextComponent variant="h5">
            Your profile is under revision
          </TextComponent>
        ) : isLiveFaceRequired ? (
          <TextComponent variant="h5">
            Your account is suspended until you complete a live face check in
            the Android app.
          </TextComponent>
        ) : (
          <TextComponent variant="h5">
            Your account is already verified
          </TextComponent>
        )}
      </ModalSimple>

      <ModalSimple
        title="Information"
        variant="secondary"
        actionExecuted={infoModalOpen}
        onClose={() => {
          setInfoModalOpen(false);
        }}
        icon={<CheckVerifyBG />}
        next
      >
        <TextComponent variant="h5">
          Your email is already verified.
        </TextComponent>
      </ModalSimple>
    </>
  );
};
